module.exports = __webpack_public_path__ + "static/media/Slider3.b0e8f84d.jpg";